<template>
  <div class="container-digital-menu">
    <div class="text-center mb-8">
      <p class="txt-title po-regular mb-0">
        <span style="color: #c9da2d;">[</span>
        Our Menu
        <span style="color: #c9da2d;">]</span>
      </p>
    </div>

    <!-- Loz Takos Menu PDF -->
    <div class="pdf-section">
      <p class="pdf-label po-medium">Loz Takos Menu</p>
      <div class="pdf-container">
        <iframe
          src="/restaurant-menu.pdf"
          class="pdf-viewer"
          title="Restaurant Menu"
        />
      </div>
    </div>

    <!-- Hot Lunch Menu PDF -->
    <div class="pdf-section mt-8">
      <p class="pdf-label po-medium">Hot Lunch Menu</p>
      <div class="pdf-container">
        <iframe
          src="/hot-lunch-menu.pdf"
          class="pdf-viewer"
          title="Hot Lunch Menu"
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DigitalMenuLayout',
  data() {
    return {}
  },
}
</script>

<style scoped>
.container-digital-menu {
  background-color: #191919;
  padding: 60px 20px;
  overflow: hidden;
}

.txt-title {
  text-align: center;
  font-size: 40px;
  letter-spacing: 0px;
  color: #fff;
  opacity: 1;
  font-weight: 500;
}

.pdf-section {
  max-width: 1000px;
  margin: 0 auto;
}

.pdf-label {
  text-align: center;
  font-size: 24px;
  letter-spacing: 0px;
  color: #dd4999;
  margin-bottom: 15px;
}

.pdf-container {
  background-color: #262626;
  border-radius: 10px;
  padding: 10px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);
}

.pdf-viewer {
  width: 100%;
  height: 80vh;
  border: none;
  border-radius: 8px;
}

@media (max-width: 600px) {
  .txt-title {
    font-size: 30px;
  }

  .pdf-label {
    font-size: 18px;
  }

  .pdf-viewer {
    height: 60vh;
  }

  .container-digital-menu {
    padding: 40px 10px;
  }
}
</style>
